import type { NewsletterSections } from '@/types';

const PHRASE_BANK: Record<keyof NewsletterSections, string[]> = {
  executiveSummary: [
    'Momentum stayed strong across the org this period.',
    'The team hit several key milestones ahead of schedule.',
    'Overall health of the business remains positive.',
    'Cross-functional collaboration drove faster delivery.',
  ],
  keyAchievements: [
    'Shipped a major feature that customers had been requesting.',
    'Closed out a long-standing technical debt initiative.',
    'Onboarded a new cohort of customers successfully.',
    'Hit a record for weekly active usage.',
  ],
  productUpdates: [
    'Rolled out an updated onboarding flow.',
    'Improved the search experience with faster results.',
    'Added support for a long-requested integration.',
    'Refreshed the dashboard with clearer visualizations.',
  ],
  engineeringProgress: [
    'Reduced average API latency through targeted optimizations.',
    'Migrated a core service to a more scalable architecture.',
    'Improved test coverage across critical code paths.',
    'Cut deployment time significantly with pipeline improvements.',
  ],
  aiInnovations: [
    'Experimented with a new model for content summarization.',
    'Piloted an AI-assisted workflow with a subset of users.',
    'Improved inference latency for the recommendation engine.',
    'Explored a retrieval-augmented approach for search relevance.',
  ],
  customerSuccessStories: [
    'A key customer reported significant time savings after adoption.',
    'Received strong positive feedback from a recent case study.',
    'One customer expanded usage across three additional teams.',
    'A long-time customer renewed with an expanded contract.',
  ],
  upcomingMilestones: [
    'Planning to launch the next major feature within the quarter.',
    'Targeting a public beta for the new workflow.',
    'Preparing for a scalability push ahead of seasonal demand.',
    'Scoping the next phase of the platform migration.',
  ],
  risksChallenges: [
    'Hiring for a key engineering role is behind schedule.',
    'A third-party dependency introduced unexpected instability.',
    'Capacity constraints may affect the next release timeline.',
    'Some customer feedback pointed to onboarding friction.',
  ],
  decisionsRequired: [
    'Need sign-off on the proposed pricing change.',
    'Leadership input needed on the vendor selection.',
    'Awaiting a go/no-go decision on the platform migration.',
    'Requesting budget approval for additional headcount.',
  ],
  appendix: [
    'Additional metrics and supporting detail are linked below.',
    'See the shared drive for the full data breakdown.',
    'Raw survey responses are available on request.',
    'Historical trend charts are attached for reference.',
  ],
};

function randomSentences(pool: string[], count: number): string {
  const picked: string[] = [];
  for (let i = 0; i < count; i++) {
    picked.push(pool[Math.floor(Math.random() * pool.length)]);
  }
  return picked.join(' ');
}

/** Generates placeholder text for every newsletter section, for exercising the editor/preview/export UI without hand-writing content. */
export function generateRandomSections(): NewsletterSections {
  const result = {} as NewsletterSections;
  for (const key of Object.keys(PHRASE_BANK) as (keyof NewsletterSections)[]) {
    result[key] = randomSentences(PHRASE_BANK[key], 2 + Math.floor(Math.random() * 2));
  }
  return result;
}
